import * as React from 'react';
import { Sorting } from '@elastic/react-search-ui';
import { Config } from '../../helper';
import { OpenSearchFacet, OpenSearchSearchBox } from '../components';

export default function StandardLayoutFilters(props) {
  const {
    facets = [],
    sorting
  } = props;

  const sortOptions = sorting.map(opt => {
    return {name: opt.label, value: opt.field, direction: opt.direction};
  });

  return (
    <div className='filters'>
      <div className='filters__header'>
        <p className='h--smaller filters__title d-flex align-items-center'>{Config.I18n.Filters.BlockLabel}</p>
      </div>

      <OpenSearchSearchBox/>

      <div className='block block--sorting'>
        <p className='h--smallest'>{Config.I18n.Filters.SortByLabel}</p>
        <Sorting sortOptions={sortOptions}/>
      </div>

      {facets.length > 0 && facets.map(facetConfig => {
        const {field, label} = facetConfig;

        return (
          <OpenSearchFacet key={field} field={field} label={label} show={20}/>
        );
      })}
    </div>
  );
}
